import { render, staticRenderFns } from "./Departamento.vue?vue&type=template&id=608970b8&"
import script from "./Departamento.vue?vue&type=script&lang=js&"
export * from "./Departamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports